import types from './types';

function habeasDataSenderReducer(state, action) {
  switch(action.type) {
    case types.SET_DESK:
      return {...state, desk: action.desk}
    case types.SET_CLIENT_DATA:
      return {...state, clientData: action.clientData}
    case types.SET_DOMINIO_CORREO:
      return {...state, clientData: {...state.clientData, dominioCorreo: action.dominioCorreo}}
    case types.ADD_IDENTITY_PHOTO_FILE:
      return {...state, identityPhoto: [...state.identityPhoto, action.file[0]]}
    case types.REMOVE_IDENTITY_PHOTO_FILE:
      return {...state, identityPhoto: action.file}
    case types.SET_IDENTIFICATION_TYPE:
        return {...state, clientData: {...state.clientData, tipoIdentificacion: action.tipoIdentificacion}}
    case types.SET_JSON_RESPONSE:
      return {...state, jsonResponse: action.jsonResponse}
      case types.SET_TWO_STEPS:
        return {...state, twoSteps: action.twoSteps}
    default:
      return state;
  }
}

export default habeasDataSenderReducer;
